"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iaMaterial = void 0;
const echain_shared_igus_fundamentals_1 = require("@igus/echain-shared-igus-fundamentals");
/**
 * Material that are used by the individual applications for IA.
 */
const allowedMaterial = ['ESD', 'EG+', 'DT'];
exports.iaMaterial = {
    [echain_shared_igus_fundamentals_1.AppName.EIQ]: allowedMaterial,
    [echain_shared_igus_fundamentals_1.AppName.EKE]: allowedMaterial,
    // EIC it's not allowed to change the material for IA's
    [echain_shared_igus_fundamentals_1.AppName.EIC]: [],
    // ECF has no IA's
    [echain_shared_igus_fundamentals_1.AppName.ECF]: [],
    [echain_shared_igus_fundamentals_1.AppName.TEST]: [],
};
//# sourceMappingURL=IaMaterial.js.map